import request from '@/utils/request'

/**
 * 飞书租户自定义分页筛选列表
 */
export const getFeishuTenantList = (params) => {
  return request({
    url: 'fin/v1/feishu/tenant/page',
    params
  })
}

/**
 * 新增飞书租户
 */
export const addFeishuTenant = (data) => {
  return request({
    method: 'POST',
    url: 'fin/v1/feishu/tenant/save',
    data
  })
}

/**
 * 删除飞书租户
 */
export const delFeishuTenant = (id) => {
  return request({
    method: 'DELETE',
    url: `fin/v1/feishu/tenant/${id}`
  })
}

/**
 * 新增飞书租户群组分页筛选
 */
export const getChatGroupList = (params) => {
  return request({
    method: 'GET',
    url: 'fin/v1/feishu/chatGroup/page',
    params
  })
}

/**
 *
 * @param {*} tenantKey 租户标识
 * @param {*} chatId 群组id
 * @returns
 */
export const delChatGroup = (tenantKey, chatId) => {
  return request({
    method: 'POST',
    url: `fin/v1/feishu/chatGroup/delGroup/${tenantKey}/${chatId}`
  })
}

/**
 * 得到艾登特机器人所在群@
 * @param {*} pageToken
 * @returns
 */
export const getChatGroupPageFs = (tenantKey, pageToken) => {
  return request({
    method: 'GET',
    url: `fin/v1/feishu/chatGroup/pageFs/${tenantKey}?pageToken=${pageToken}`
  })
}

/**
 * 根据id获取信息
 * @param {*}
 * @returns
 */
export const getFeishuTenantMessage = (id) => {
  return request({
    method: 'GET',
    url: `fin/v1/feishu/tenant/${id}`
  })
}
